import swal from 'sweetalert2'
import WebFont from 'webfontloader'
import Turbolinks from 'turbolinks'

import 'devextreme/dist/css/dx.common.css'
import 'devextreme/dist/css/dx.material.orange.light.compact.css'

/**
 * JS Settings App
 */
let jsonSettings = document.querySelector(
  '[data-settings-selector="settings-json"]'
)
window.settings = jsonSettings ? JSON.parse(jsonSettings.textContent) : {}

window.swal = swal

export default createApp => {
  Turbolinks.start()

  /**
   * Font
   */
  WebFont.load({
    google: {
      families: ['Open Sans', 'Roboto']
    }
  })

  /**
   * Cookie Consent
   */
  // window.addEventListener('load', () => {
  //   window.cookieconsent.initialise({
  //     palette: {
  //       popup: {
  //         background: '#fff',
  //         text: '#777'
  //       },
  //       button: {
  //         background: '#3097d1',
  //         text: '#ffffff'
  //       }
  //     },
  //     showLink: false,
  //     theme: 'edgeless',
  //     content: {
  //       message: window.settings.cookieconsent.message,
  //       dismiss: window.settings.cookieconsent.dismiss
  //     }
  //   })
  // })

  document.addEventListener('turbolinks:load', () => {
    /**
     * Vue Mounting
     */
    if (document.getElementById('app') !== null) {
      const { app } = createApp()
      app.$mount('#app')
    }
  })
}
